<template>
	<div class="page">
		<Breadcrumb :pathList='pathList'></Breadcrumb>
		<div class="content">
			<div v-for="(item,index) in sessionCarChapters">
				<div class="flex flex-b">
					<div class="flex" style="margin-top: 20px;">
						<img :src="item.img" style="width: 138px;height: 78px;border-radius: 13px;" />
						<div class="right flex-1">
							<div class="name">{{item.course_name}}</div>
							<!-- <div class="xy">加工中心学院</div> -->
						</div>
					</div>
					<div class="pointer">
						<img v-if="item.drownFlag" @click="drownClick(item,false)"
							src="../../assets/images/icon/ixl.png" style="width: 14px;height: 8px;" />
						<img v-else @click="drownClick(item,true)" src="../../assets/images/icon/ixl.png"
							style="width: 14px;height: 8px;transform: rotate(180deg);" />
					</div>
				</div>
				<div class="gbox" v-if="item.drownFlag">
					<div class="titles" style="margin-top: 0;">购买章节</div>
					<div class="flex-only botl" v-for="(_item,_index) in item.chapter">
						<div class="num">第{{_index+1}}章</div>
						<div class="flex-1">
							<div class="flex flex-b">
								<div class="name">{{_item.name}}</div>
								<div class="score">{{_item.member_score}}<span>积分</span></div>
							</div>
							<div class="flex flex-b">
								<!-- <div class="long">12分钟/视频</div> -->
								<div class="long" v-if="_item.type==1">
									{{parseFloat(_item.file.second/60).toFixed(1)<=1?parseFloat(_item.file.second)+'秒':parseFloat(_item.file.second/60).toFixed(1)+'分钟'}}/视频
								</div>
								<div class="long" v-if="_item.type==2">
									{{parseFloat(_item.file.second/60).toFixed(1)<=1?parseFloat(_item.file.second)+'秒':parseFloat(_item.file.second/60).toFixed(1)+'分钟'}}/音频
								</div>
								<div class="long" v-if="_item.type==3">PDF</div>
								<div class="long" v-if="_item.type==4">PPT</div>
								<div class="linePrice">{{_item.score}}积分</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="wbox">
				<div class="tit">会员优惠</div>
				<div class="flex flex-b">
					<div class="flex mt10">
						<img src="../../assets/images/course/hgImg.png" style="width: 27px;height: 27px;" alt="" />
						<div class="vipName">{{loginUser.member?loginUser.member.name:''}}</div>
					</div>
					<div class="score2">-{{loginUser.member?loginUser.member.discount:0}}<span>积分/章节</span></div>
				</div>
			</div>
			<div class="wbox">
				<div class="tit">购买合计</div>
				<div class="flex flex-b mt10">
					<div class="t">合计原价</div>
					<div class="score3">{{selectTotalScoreOrig}}<span>积分</span></div>
				</div>
				<div class="flex flex-b mt10">
					<div class="t">合计会员折扣</div>
					<div class="score2">-{{selectTotalScoreOrig-selectTotalScore}}<span>积分</span></div>
				</div>
				<div class="flex flex-b" style="border-top: 1px solid #EEEEEE;padding-top: 10px;margin-top: 10px;">
					<div class="t" style="font-weight: 600;">实付积分</div>
					<div class="score4">{{selectTotalScore}}<span>积分</span></div>
				</div>
			</div>
			<div class="flex" style="margin-top: 60px;">
				<img src="../../assets/icon/wxz.png" v-if="!selectRule" @click="selectRule=!selectRule" class="pointer"
					style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
				<img src="../../assets/icon/xz.png" v-else @click="selectRule=!selectRule" class="pointer"
					style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
				<div class="tip">我已阅读并同意以下内容<span class="pointer">报名须知</span>以及<span class="pointer">合同条款</span></div>
			</div>
		</div>
		<div class="bottomFixed flex flex-b">
			<div>
				<div class="score4">{{selectTotalScore}}<span>积分</span></div>
				<div class="mt10 t1">已选{{chapterNum}}个章节</div>
			</div>
			<div class="login-btn pointer" @click="buyClick"><span class="text">立即购买</span></div>
		</div>

		<el-dialog :visible.sync="buySuccess" width="382" center :show-close="false">
			<div class="flex-column-item">
				<img src="../../assets/images/course/success.png" style="width: ;height: 53px;" alt="" />
				<div class="mt10" style="font-size: 16px;color: #666666;">已完成购买，本次共购买{{chapterNum}}个章节</div>
			</div>
			<div class="flex flex-b">
				<div class="wxbtn pointer" style="width: 156px;height: 46px;" @click="buySuccess=false,$router.push('/allCourse')">我知道了</div>
				<div class="login-btn pointer" @click="$router.push('/allCourse')">
					<span class="text">前往学习</span>
				</div>
			</div>
		</el-dialog>

		<!-- <Toast ref="toastRef"></Toast> -->
	</div>
</template>

<script>
	import Utils from "@/jslibs/utils";
	import {
		getMyCourse,
		getUser,
		EditUser,
	} from '@/api/mine';
	import {
		buyCourseOrder
	} from "@/api/course";
	import Toast from '../../components/Toast.vue';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	export default {
		data() {
			return {
				buySuccess: false,
				pathList: [{
						title: '我的',
						path: '/mine'
					},
					{
						title: '购物车',
						path: '/myCart'
					},
					{
						title: '课程购买',
						path: ''
					}
				],
				show: false,
				loginUser: '',
				sessionCarChapters: [],
				selectTotalScore: 0,
				selectTotalScoreOrig: 0,
				selectRule: false,
				chapterNum: 0
			}
		},
		components: {
			Toast,
			Breadcrumb
		},
		mounted() {
			this.chapterNum = this.$route.query.chapterNum
			this.selectTotalScore = this.$route.query.selectTotalScore
			this.selectTotalScoreOrig = this.$route.query.selectTotalScoreOrig
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
			if (localStorage.getItem("sessionCarChapters")) {
				this.sessionCarChapters = JSON.parse(localStorage.getItem("sessionCarChapters")); // TODO: 先设三天过期  */
				this.sessionCarChapters.forEach(item => {
					this.$set(item, 'drownFlag', false)
				})
			}
			// this.$nextTick(() => {
			// 	this.$refs.toastRef.openToast('所选章节已下架')
			// 	// this.$refs.toastRef.openToast('章节价格发生变化，请重新生成订单')
			// 	// this.$refs.toastRef.openToast('账户余额不足')
			// 	// this.$refs.toastRef.openToast('交易状态异常，请重新发起订单')
			// 	// this.$refs.toastRef.openToast('课程已下架')
			// })
		},
		methods: {
			async buyClick() {
				if (!this.selectRule) {
					this.$message({
						message: "请阅读并同意以下内容《报名须知》以及《合同条款》",
						type: "warning"
					});
					return
				}
				const buyParams = {
					type: 1,
				}
				let arrs = []
				this.sessionCarChapters.forEach(item => {
					item.chapter.forEach(_item => {
						arrs.push(_item.uuid)
					})
				})
				const {
					status,
					data
				} = await buyCourseOrder({
					type: 2,
					chapter_uuid: arrs
				});
				if (data.result) {
					this.buySuccess = true
				}
			},
			drownClick(item, flag) {
				this.$set(item, 'drownFlag', flag)
			},
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = data.result
			},
			goBack() {
				this.$router.go(-1)
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
		},
	}
</script>

<style lang="less" scoped>
	.login-btn {
		width: 160px;
		height: 52px;
		background: url('../../assets/images/course/btnw164.png') no-repeat;
		background-size: 100% 100%;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.wxbtn {
		margin-top: 20px;
		width: 360px;
		height: 51px;
		border-radius: 12px 12px 12px 12px;
		border: 2px solid rgba(127, 218, 76, .24);
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.page {
		padding: 30px 133px 120px;

		.content {
			margin: 30px 233px 0;
			border-top: 4px solid rgba(0, 167, 60, 0.24);

			.right {
				margin-left: 20px;

				.name {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 18px;
					color: #000000;
				}

				.xy {
					margin-top: 10px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
				}
			}

			.gbox {
				margin-top: 10px;
				background: #FAFBFC;
				border-radius: 13px 13px 13px 13px;
				padding: 16px 20px;

				.all {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}
			}

			.botl {
				padding: 0 0 12px;
				margin-bottom: 10px;
				border-bottom: 1px solid #EEEEEE;

				&:last-child {
					border-bottom: none;
					margin-bottom: 0;
					padding-bottom: 0;
				}
			}

			.num {
				padding-top: 5px;
				margin-right: 20px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #999999;
			}

			.name {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
			}

			.long {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
			}

			.wbox {
				background: #FFFFFF;
				box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
				border-radius: 13px 13px 13px 13px;
				padding: 20px;
				margin: 20px 0;

				.tit {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 18px;
					color: #333333;

				}

				.vipName {
					margin-left: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #D7B155;
				}

				.score2 {
					font-family: DINPro, DINPro;
					font-weight: 500;
					font-size: 18px;
					color: #D7B155;

					span {
						margin-left: 6px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #D7B155;
					}
				}

				.score3 {
					font-family: DINPro, DINPro;
					font-weight: 500;
					font-size: 18px;
					color: #333333;

					span {
						margin-left: 6px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #333333;
					}
				}

				.t {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}
			}

			.tip {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;

				span {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 13px;
					color: #00A73C;
				}
			}
		}

		.mt10 {
			margin-top: 10px;
		}

		.score4 {
			font-family: DINPro, DINPro;
			font-weight: bold;
			font-size: 22px;
			color: #00A73C;

			span {
				margin-left: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
			}
		}

		.bottomFixed {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			padding: 20px 356px;

			.t1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #000000;
			}

			.login-btn {
				width: 276px;
				height: 50px;
				background: url('../../assets/images/login/loginbtn.png') no-repeat;
				background-size: 100% 100%;
				margin-top: 13px;
				display: flex;
				align-items: center;
				justify-content: center;

				.text {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
					text-align: center;
					font-style: normal;
					text-transform: none;
					background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}
		}
	}
</style>